export const locale = {
    lang: 'fr',
    data: {
        STUDIO_PROJECTS_NEW_PARENT_CREATE: 'Créer un projet',
        STUDIO_PROJECTS_NEW_PARENT_GENERAL: 'Général',
        STUDIO_PROJECTS_NEW_PARENT_PROJECT_STRUCTURE: 'Structure du projet',
        STUDIO_PROJECTS_NEW_PARENT_MEMBERS: 'Membres',
    }
};
